
export default {
  name: "DoubleBlock",
};
